import React from 'react'
import numeral from 'numeral'

import { useCashoutAvailable } from '../../hooks/use-cashout-available'
import styles from './cashout-resume.module.css'
import Iconify from '../../../Iconify'

// Assets
import moneyIcon from '../../../../assets/images/cash1-100.png'

export const CashoutResume = () => {
  const { data: cashoutAvailable, isLoading } = useCashoutAvailable()
  const available = cashoutAvailable?.available ?? 0
  const unavailable = cashoutAvailable?.unavailable ?? 0

  if (isLoading) {
    return (
      <div className={styles.wrap} aria-busy="true" aria-label="Cargando saldos">
        <div className={styles.grid}>
          <div className={`${styles.card} ${styles.skeleton}`} />
          <div className={`${styles.card} ${styles.skeleton}`} />
        </div>
      </div>
    )
  }

  return (
    <section className={styles.wrap} aria-label="Resumen de saldo">
      <h2 className={styles.title}><Iconify icon='mdi:bank' /> Resumen de Balance</h2>
      <div className={styles.grid}>
        <article className={`${styles.card} ${styles.cardAvailable}`}>
          <span className={styles.accent} aria-hidden />
          <h2 className={styles.label}>Saldo disponible para retiro</h2>
          <p className={styles.amountContainer}>
            <img src={moneyIcon} alt="Money" width={30} />
            <span className={styles.amount}>{numeral(available).format('$0,000.00')}</span> <small>MXN</small>
          </p>
        </article>
        <article className={`${styles.card} ${styles.cardUnavailable}`}>
          <span className={`${styles.accent} ${styles.accentMuted}`} aria-hidden />
          <h2 className={styles.label}>Saldo no retirable</h2>
          <p className={styles.amountContainer}>
            <img src={moneyIcon} alt="Money" width={30} className={styles.moneyIconGray} />
            <span className={styles.amount}>{numeral(unavailable).format('$0,000.00')}</span> <small>MXN</small>
          </p>
        </article>
      </div>
    </section>
  )
}
